import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import useSWR from 'swr';
import { Helmet } from 'react-helmet';
import { t } from 'ttag';

import { Heading } from '@components';
import { Breadcrumbs } from '@modules';

import { Categories, Questions } from '../components';

const fetcher = url => fetch(url).then(r => r.json());

export default function Category() {
  const history = useHistory();
  const { category } = useParams();

  const { data: categoryData } = useSWR(
    `/api/faq/categories/${category}/`,
    fetcher
  );

  const handleHistoryPush = useCallback(
    (event, url) => {
      event.preventDefault();
      history.push(url);
    },
    [history]
  );

  return (
    <>
      {categoryData?.data?.attributes?.seo_title && (
        <Helmet>
          <title>{categoryData?.data?.attributes?.seo_title}</title>
        </Helmet>
      )}
      {categoryData?.data?.attributes?.seo_description && (
        <Helmet>
          <meta
            name="description"
            content={categoryData?.data?.attributes?.seo_description}
          />
        </Helmet>
      )}

      <div className="min-h-screen bg-whisper pb-8 md:pb-16">
        <div className="container space-y-8 px-0 py-4 sm:px-2 sm:py-8 md:space-y-16">
          <section>
            <Breadcrumbs>
              <Breadcrumbs.Breadcrumb href="/">{t`Frontpage`}</Breadcrumbs.Breadcrumb>
              <Breadcrumbs.Breadcrumb
                href="/faq/"
                onClick={event => handleHistoryPush(event, '/')}
              >
                {t`FAQ`}
              </Breadcrumbs.Breadcrumb>
              <Breadcrumbs.Breadcrumb
                href={`/faq/${categoryData?.data?.attributes?.url_name}/`}
                isActive
                onClick={event =>
                  handleHistoryPush(
                    event,
                    `/${categoryData?.data?.attributes?.url_name}/`
                  )
                }
              >
                {categoryData?.data?.attributes?.title}
              </Breadcrumbs.Breadcrumb>
            </Breadcrumbs>
            <Heading className="flex min-h-[92px] items-center break-words lg:min-h-[64px]">
              {categoryData?.data?.attributes?.title || ''}
            </Heading>
          </section>
          <main className="space-y-8">
            <Heading
              as="h2"
              className="hidden break-words text-3xl normal-case lg:block"
            >
              {t`How can we help you?`}
            </Heading>
            <div className="space-y-8 lg:grid lg:grid-cols-3 lg:gap-16 lg:space-y-0">
              <section className="hidden space-y-4 lg:col-span-1 lg:block">
                <Categories />
              </section>
              <section className="space-y-4 lg:col-span-2">
                <Questions />
              </section>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
